import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";

import MenuProv from "../ComponenProveedor/ProvMenu/ProvMenu";
import MenuPhone from "../ComponenProveedor/ProvMenuPhone/ProvMenuPhone";
import ProfileProveedor from "../ProfileProveedor/ProfileProveedor";
import UpdateBillProveedor from "../UpdateBillProveedor/updateBillProveedor";
import ChangePasswordPorveedor from "../ChangePasswordProveedor/ChangePasswordProveedor";
import Welcome from "../welcome/welcome";

const IndexProveedor = () => {
  const [viewSeeProv, setViewPageProv] = useState(null);
  //const [alertid, setAlertId] = useState(null);
  const location = useLocation();
  let data = location.state;

  const tipeviewSee = (datos) => {
    setViewPageProv(datos);
  };

  if (!data) {
    const storedData = sessionStorage.getItem("Data");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles
    sessionStorage.setItem("Data", JSON.stringify(data));
  }

  /*useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ALERTS_SUPPLIER);

        if (response.data.length > 0 && response.data.includes(data.id)) {
          setAlertId(data.id);
        }
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    };

    fetchData();
  }, [data.id]);*/

  return (
    <div className="boxprovmenuallmenu">
      <MenuProv viewSee={tipeviewSee} />
      <MenuPhone viewSee={tipeviewSee} />

      {viewSeeProv === "Perfil" ? <ProfileProveedor /> : null}
      {viewSeeProv === "Factura" ? <UpdateBillProveedor data={data} /> : null}

      {viewSeeProv === "Contraseña" ? (
        <ChangePasswordPorveedor data={data} />
      ) : null}
      {viewSeeProv === null && <Welcome data={data} />}
    </div>
  );
};

export default IndexProveedor;
